import React, { ReactNode } from "react"
import clsx from "clsx"
import * as styles from "./switcherTextBlock.module.scss"
import { items } from "./helpers/items"
import { Variant } from "./types"
import { QueryTypePsk } from "../../helpers/getVariableFromQuery"

type ContentProps = {
  variant?: Variant
  queryData?: QueryTypePsk | null
  bottomText?: ReactNode
}

const pskJsx = (queryValues: QueryTypePsk) => (
  <div className={styles.aboutBlock}>
    <p className={styles.aboutTitle}>ПСК</p>
    <p className={styles.aboutText}>{queryValues?.value}</p>
  </div>
)

const Content = ({ variant = "standard", queryData, bottomText }: ContentProps) => (
  <div className={styles.htmlBlock}>
    {queryData && pskJsx(queryData)}
    {items[variant].map((item) => (
      <div className={clsx(styles.aboutBlock, variant && styles[variant])}>
        <p className={styles.aboutTitle}>{item.title}</p>
        <p className={styles.aboutText}>{item.text}</p>
      </div>
    ))}
    {bottomText && <div className={styles.bottomTextContent}>{bottomText}</div>}
  </div>
)

export default Content
